import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, Mail } from "lucide-react";
import { Button } from "./ui/button";

export const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/academy", label: "Football X Academy" },
    { path: "/elite-trial-prep", label: "Elite Trial Prep" },
    { path: "/joeys", label: "Joeys Program" },
    { path: "/social", label: "Football X Media" },
    { path: "/sponsor", label: "Become a Sponsor" },
    { path: "/shop", label: "Shop" },
  ];

  return (
    <nav className="bg-black text-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-3">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_4d83666a-aa6c-4973-8e91-b3c87719f098/artifacts/zqkw8qrg_sports-logo-generator-for-a-soccer-team-league-5384a-el1%20%286%29.webp"
              alt="Football X Academy"
              className="h-12 w-auto"
              data-testid="nav-logo"
            />
            <div className="text-xl font-bold">
              <span className="text-white">FOOTBALL</span>
              <span className="text-cyan-400 ml-1">X</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-5">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`hover:text-cyan-400 transition-colors duration-200 font-medium text-sm whitespace-nowrap ${
                  location.pathname === link.path ? "text-cyan-400" : ""
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden text-white hover:text-cyan-400"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </Button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden pb-4 border-t border-gray-600 mt-4 pt-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block py-2 hover:text-cyan-400 transition-colors duration-200 ${
                  location.pathname === link.path ? "text-cyan-400" : ""
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            
            <div className="mt-4 pt-4 border-t border-gray-600">
              <div className="flex items-center space-x-2 py-2">
                <Mail className="w-4 h-4 text-cyan-400" />
                <span className="text-sm">paul.minett@football-x.com.au</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};